
import { motion } from 'framer-motion';

export default function AboutSection() {
  return (
    <section id="about" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-bold text-gray-900 mb-4">会社概要</h2>
          <p className="text-xl text-gray-600">ADVERTISING AGENCY VAN CO., LTD</p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <motion.div 
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="space-y-6"
          >
            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">企業理念</h3>
              <div className="space-y-4">
                <div className="border-l-4 border-blue-600 pl-4">
                  <h4 className="font-bold text-lg text-blue-600 mb-2">IDENTITY INSPIRATION IDEA</h4>
                  <p className="text-gray-700 leading-relaxed">
                    確固としたアイデンティティと完成されたアイデアを持ち、そして常にインスピレーションを求め続けるクリエイティブな集団として、VANは社会へ、そしてデジタル時代へ積極的にコンタクトしていきます。
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">新日東グループの総合力</h3>
              <p className="text-gray-700 leading-relaxed">
                工事施工ノウハウを活かしたイベント施工、看板工事など、グループの総合力で企業様の様々なニーズにお応えいたします。確固とした哲学と企業としての意思表明で、美しい文化・環境を創造します。
              </p>
            </div>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="space-y-6 h-full"
          >
            <div className="relative">
              <img 
                src="https://static.readdy.ai/image/c0a14dc189bb3eb0b6d6716d0af92e52/5c50075b467c5259e2bff6400b6cdf10.jfif"
                alt="新日東オフィス"
                className="rounded-2xl shadow-lg w-full h-64 object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent rounded-2xl"></div>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <motion.div 
                whileHover={{ scale: 1.05 }}
                className="bg-white rounded-xl p-6 shadow-lg text-center"
              >
                <div className="text-3xl font-bold text-blue-600 mb-2">1965</div>
                <div className="text-sm text-gray-600">設立年</div>
              </motion.div>
              <motion.div 
                whileHover={{ scale: 1.05 }}
                className="bg-white rounded-xl p-6 shadow-lg text-center"
              >
                <div className="text-3xl font-bold text-blue-600 mb-2">1000万円</div>
                <div className="text-sm text-gray-600">資本金</div>
              </motion.div>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-lg">
              <h4 className="font-bold text-lg text-gray-900 mb-4">基本情報</h4>
              <div className="space-y-2 text-sm text-gray-700">
                <p><span className="font-medium">代表者:</span> 代表取締役 近藤和裕</p>
                <p><span className="font-medium">所在地:</span> 〒371-0854 群馬県前橋市大渡町1-23-13</p>
                <p><span className="font-medium">TEL:</span> 027-255-2214</p>
                <p><span className="font-medium">FAX:</span> 027-255-2324</p>
                <p><span className="font-medium">Email:</span> infovan@shinnitto.jp</p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
